import { render, staticRenderFns } from "./Haloween.vue?vue&type=template&id=e4262232&scoped=true&"
import script from "./Haloween.vue?vue&type=script&lang=js&"
export * from "./Haloween.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4262232",
  null
  
)

export default component.exports